import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import SpeakerNotesOffIcon from '@material-ui/icons/SpeakerNotesOff';
import ChatIcon from '@material-ui/icons/Chat';

import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import PaperMaterial from '@material-ui/core/Paper';

import Can from '~/contexts/Can';
import { AbilityContext } from '~/contexts/Can';

import OpenChats from './OpenChats';
import ClosedChats from './ClosedChats';

function ChatList() {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);

  const [tab, setTab] = useState('1');

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <TabContext value={tab}>
        <PaperMaterial>
          <TabList
            variant="scrollable"
            textColor="secondary"
            onChange={handleChange}
          >
            <Tab
              icon={<ChatIcon />}
              label={t('chats.extras.openChats')}
              value="1"
              disabled={ability.cannot('list', 'Chats')}
            />
            <Tab
              icon={<SpeakerNotesOffIcon />}
              label={t('chats.extras.closedChats')}
              value="2"
              disabled={ability.cannot('list', 'Chats')}
            />
          </TabList>
        </PaperMaterial>

        <Can I="list" a="Chats">
          <TabPanel value="1">
            <OpenChats />
          </TabPanel>
        </Can>

        <Can I="list" a="Chats">
          <TabPanel value="2">
            <ClosedChats />
          </TabPanel>
        </Can>
      </TabContext>
    </>
  );
}

export default React.memo(ChatList);
